import PostCard from '@/components/Post/PostCard';
import { useGetPostByUsernameQuery } from './post.api.slice';
import { Skeleton } from '@/components/ui/skeleton';
import NoPosts from '@/components/Illustrations/NoPosts';

function UserPostsList({
  username,
  userId,
}: {
  username: string;
  userId: string;
}) {
  const { data: userPosts, isLoading } = useGetPostByUsernameQuery(username);

  if (isLoading)
    return (
      <div className="flex flex-wrap gap-5 items-center justify-center">
        {Array.from({ length: 12 }).map((_, index) => (
          <Skeleton key={index} className="w-[320px] h-[320px]" />
        ))}
      </div>
    );

  if (userPosts?.length === 0) {
    return (
      <div className="flex items-center justify-center">
        <NoPosts />
      </div>
    );
  }

  return (
    <div className="flex flex-wrap sm:justify-start justify-center py-2 w-full gap-10 items-center">
      {userPosts?.map((post) => (
        <PostCard
          key={post._id}
          id={post._id}
          authorName={`${post.user.firstname} ${post.user.lastname}`}
          authorAvatar={post.user.profilePicture}
          authorUsername={post.user.username}
          title={post.title}
          likesCount={post.likes}
          commentsCount={post.comments}
          attachments={post.attachments}
          createdAt={post.createdAt}
          category={post.category}
          description={post.description}
          hasLikedByUser={post.hasLikedByUser}
          isOnefinityOfficial={post.user.isOnefinityOfficial}
          isOwner={post.user._id === userId}
          visibility={post.visibility}
          partnerData={post?.partner}
        />
      ))}
    </div>
  );
}

export default UserPostsList;
